import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./PdfViewer.css";

const DEFAULT_PDF_URL =
  "https://jum-email-signature.s3.us-east-2.amazonaws.com/Employee+Handbook.pdf";

export default function PdfViewer() {
  const location = useLocation();
  const navigate = useNavigate();

  // support being opened with router state { url, title }
  const passed = (location && location.state) || {};
  const pdfUrl = passed.url || DEFAULT_PDF_URL;
  const title = passed.title || "Safety & Health Handbook — 2026";
  // simple state for zoom + open/download controls
  const [scale, setScale] = useState(1);

  function zoomIn() {
    setScale((s) => Math.min(3, s + 0.25));
  }
  function zoomOut() {
    setScale((s) => Math.max(0.5, s - 0.25));
  }
  function resetZoom() {
    setScale(1);
  }

  return (
    <div className="handbook-root">
      <div
        className="handbook-toolbar"
        role="toolbar"
        aria-label="PDF viewer controls"
      >
        <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
          <button
            onClick={() => navigate(-1)}
            className="button"
            aria-label="Back to list"
          >
            ← Back
          </button>
          <div className="handbook-title">{title}</div>
        </div>

        <div className="handbook-controls">
          <a
            className="button primary"
            href={pdfUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Open in new tab"
          >
            Open
          </a>

          <a
            className="button"
            href={pdfUrl}
            download
            aria-label="Download PDF"
          >
            Download
          </a>

          {/* <button className="button" onClick={zoomOut} aria-label="Zoom out">
            −
          </button>
          <button className="button" onClick={zoomIn} aria-label="Zoom in">
            +
          </button>
          <button
            className="button"
            onClick={resetZoom}
            aria-label="Reset zoom"
          >
            Reset
          </button> */}
        </div>
      </div>

      <div className="handbook-viewer">
        {/*
          <object> is preferable for built-in fallback support: if the browser
          cannot display the PDF it will render the inner fallback content.
        */}
        <object
          data={pdfUrl}
          type="application/pdf"
          width="100%"
          height="100%"
          className="handbook-object"
          aria-label="Safety & Health Handbook PDF"
        >
          <div className="fallback-container">
            <div className="handbook-fallback">
              <p>
                It looks like your browser can't display the PDF. You can
                download or open the file with a PDF viewer instead.
              </p>

              <div className="fallback-actions">
                <a
                  href={pdfUrl}
                  className="button primary"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Open in new tab
                </a>
                <a href={pdfUrl} className="button" download>
                  Download PDF
                </a>
              </div>
            </div>
          </div>
        </object>

        {/* Decorative wrapper to apply zoom via transform */}
        <div
          className="handbook-overlay"
          style={{ transform: `scale(${scale})` }}
          aria-hidden
        />
      </div>

      <noscript className="handbook-noscript">
        JavaScript is disabled — you can still download the handbook directly:
        <a href={pdfUrl} download>
          Download the Safety & Health Handbook (PDF)
        </a>
      </noscript>
    </div>
  );
}
